import React from 'react';

const OurMoat = () => {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-8 text-center">
          OUR MOAT 🌊
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed text-center">
          Our moat is built on four reinforcing layers. We benefit from strong two-sided network effects that compound as we add demand, supply, and new service verticals. We're positioning as the affordable, trusted value brand for local services, which expands our market and drives repeat usage. Our AI-native infrastructure gives us a structural cost advantage over brick and mortar & franchise-based competitors, allowing us to price lower while maintaining stronger margins. And over time, service-members develop high switching costs as they build full schedules, recurring clients, and affiliate income inside our ecosystem.
        </p>
      </div>
    </section>
  );
};

export default OurMoat;
